import { PageHeader } from "@/components/common";
import { Music, Users, Clock, Heart } from "lucide-react";

const values = [
  { icon: Music, title: "Music", text: "Every event is curated around sound, atmosphere and artistry." },
  { icon: Users, title: "People", text: "We bring communities together through shared live moments." },
  { icon: Clock, title: "Moments", text: "Nights designed to be remembered long after the lights fade." },
  { icon: Heart, title: "Together", text: "Experiences that connect artists and audiences as one." },
];

export default function About() {
  return (
    <div data-testid="about-page">
      <PageHeader caption="Who We Are" title="About Sirakh Creations"
        subtitle="We design premium live experiences — concerts, festivals and nights built around music, people, moments and togetherness." />
      <div className="mx-auto max-w-5xl px-4 pb-10 sm:px-8">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((v) => (
            <div key={v.title} className="card-dark p-6 text-center">
              <v.icon className="mx-auto text-[#D4AF37]" size={28} />
              <h3 className="mt-4 font-serif text-xl font-semibold">{v.title}</h3>
              <p className="mt-2 text-sm text-zinc-400">{v.text}</p>
            </div>
          ))}
        </div>
        <div className="card-dark mt-10 p-8">
          <p className="leading-relaxed text-zinc-300">
            Sirakh Creations is a premium events brand dedicated to crafting unforgettable live experiences.
            From intimate showcases to large-scale productions, we obsess over every detail — the lineup, the venue,
            the lighting and the energy — so that every guest leaves with a story worth telling.
          </p>
        </div>
      </div>
    </div>
  );
}
